import color from "color-convert";

const SHADE_SHIFT_AMOUNT = 0.05;

export const lighten = (
  colorValue: string,
  amount: number = SHADE_SHIFT_AMOUNT
): string => {
  const hsl = color.hex.hsl(colorValue);
  hsl[2] = Math.min(hsl[2] + amount * 100, 100);
  return "#" + color.hsl.hex(hsl);
};

export const darken = (
  colorValue: string,
  amount: number = SHADE_SHIFT_AMOUNT
): string => {
  const hsl = color.hex.hsl(colorValue);
  hsl[2] = Math.max(hsl[2] - amount * 100, 0);
  return "#" + color.hsl.hex(hsl);
};
